import { createContext, useReducer, useEffect } from 'react';

export const AuthContext = createContext();

export const authReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      localStorage.setItem('user', JSON.stringify(action.payload)); // ✅ User opslaan in localStorage
      localStorage.setItem('token', action.payload.token); // ✅ Token opslaan
      localStorage.setItem('roles', JSON.stringify(action.payload.roles || [])); // ✅ Rollen als array opslaan

      return { user: action.payload };
      
    case 'LOGOUT':
      localStorage.removeItem('user');
      localStorage.removeItem('token'); // ✅ Token verwijderen
      localStorage.removeItem('roles'); // ✅ Rollen verwijderen

      return { user: null };

    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, { user: null });

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    const token = localStorage.getItem('token');
    const roles = JSON.parse(localStorage.getItem('roles')) || []; // ✅ Rollen als array ophalen

    if (user && token) {
      dispatch({ type: 'LOGIN', payload: { ...user, token, roles } }); // ✅ User & token & roles in state zetten
    }
  }, []);

  console.log('🔹 AuthContext state:', state); // ✅ Debug log

  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
